import { useState } from "react";
import { Grid, Row } from "antd";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { RATypography } from "@/components/customs";
import { RAButtonSecondary, RAImage } from "@/components/customs";
import { ModalRequestQuote, ModalStatus, ModalActiveAccount } from "../../Modals";
import { selectAuthState } from "@/stores/slices/authSlice";
import { NOTIFICATION_TYPE } from "@/config/constants";

const { useBreakpoint } = Grid;

export function PrivateJetTravelHeroSection({ banner = {} }) {
	const screens = useBreakpoint();
	const { user } = useSelector(selectAuthState);
	const [showRequestFlight, setShowRequestFlight] = useState(false);
	const [showStatus, setShowStatus] = useState(false);
	const [showModalActiveAccount, setShowModalActiveAccount] = useState(false);

	const onPressRequestQuote = () => {
		if (user && !user.activated) {
			setShowStatus(true);
			return;
		}
		setShowRequestFlight(true);
	};

	return (
		<div style={{ width: "100%", position: "relative" }}>
			<WrapperSection>
				<div style={{ position: "relative" }}>
					<RAImage
						url={screens.xs ? banner?.mobile_banner : screens.sm ? banner?.desktop_banner : ""}
						width="100%"
						height="100vh"
					/>
					<DarkOverlay />
				</div>
				<WrapperContent>
					<TextContainer className="animate__animated animate__fadeInUp animate__slow">
						<RATypography
							variant={screens?.md ? "h1" : "h2"}
							color="#fff"
							style={{ display: "inline" }}
							whiteSpace="pre-wrap"
						>
							{banner?.title || ""}
						</RATypography>
					</TextContainer>

					<WrapperQuote className="animate__animated animate__fadeInUp">
						<RAButtonSecondary
							background="#fff"
							title={banner?.button_content || "REQUEST A QUOTE"}
							onClick={() => onPressRequestQuote()}
							width="100%"
							border="none"
						/>
					</WrapperQuote>
					{/* modals */}
					<ModalRequestQuote visible={showRequestFlight} onClose={() => setShowRequestFlight(false)} />
				</WrapperContent>
			</WrapperSection>

			{/* modals */}
			<ModalStatus
				visible={showStatus}
				status={NOTIFICATION_TYPE.ERROR}
				title="You haven't verified your OTP yet!"
				note="Please verify your OTP to access all the features and benefits of our products"
				onClose={() => setShowStatus(false)}
				footer={
					<Row>
						<RAButtonSecondary
							title="VERIFY NOW"
							onClick={() => {
								setShowStatus(false);
								setTimeout(() => {
									setShowModalActiveAccount(true);
								}, 200);
							}}
						/>
					</Row>
				}
			/>
			<ModalActiveAccount
				visible={showModalActiveAccount}
				onClose={() => setShowModalActiveAccount(false)}
				onActiveSuccess={() => {
					setShowRequestFlight(true);
				}}
			/>
		</div>
	);
}

const WrapperSection = styled.div`
	width: 100%;
`;

const TextContainer = styled.div`
	text-align: center;
	background: linear-gradient(180deg, #ffffff 39.72%, rgba(255, 255, 255, 0) 140.65%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
`;
const WrapperContent = styled.div`
	position: absolute;
	top: 25%;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
`;
const WrapperQuote = styled.div`
	padding-top: 30px;
	max-width: 280px;
	--animate-duration: 3s;
`;
const DarkOverlay = styled.div`
	background-color: rgba(0, 0, 0, 0.3);
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
`;
